import React from 'react'
import logo from "../assets/logo.svg"
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { searchTask } from '../features/filter/filterSlice'

export default function Navbar() {
    const dispatch = useDispatch()

    function handleSearch(value) {
        dispatch(searchTask(value))
    }

    return (
        <nav className="container relative py-3">
            <div className="flex items-center justify-between">
                <Link to="/">
                    <img src={logo} alt='logo' />
                </Link>
                <div className="flex-1 max-w-xs search-field group">
                    <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
                    <input type="text" placeholder="Search Task" onChange={e => {
                        handleSearch(e.target.value)
                    }} className="search-input" style={{ color: "black" }} id="lws-searchTask" />
                </div>
            </div>
        </nav>
    )
}
